import { Alert, Button, Form, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import { useSetCodeUserMutation } from '../../../api/v2/articleCodes'
import { useMyContext } from '../../../context/context'
import useTranslations from '../../../hooks/useTranslations'
import useSettingsV2 from '../../../hooks/useSettingsV2'

export default function ResumeCode({ resume }) {
  const [show, setShow] = useState(false)

  const { myContext } = useMyContext()
  const { settings } = useSettingsV2()

  const { t } = useTranslations()
  const [form] = Form.useForm()

  const [setCodeUser, { isLoading, error }] = useSetCodeUserMutation()

  useEffect(() => {
    if (show && resume?.code?.code && form) {
      form.setFieldsValue({ code: resume.code.code })
    }
  }, [form, resume, show])

  return show ? (
    <>
      <Form
        form={form}
        onFinish={async v => {
          if (resume?.promoCode?.code === v.code) {
            setShow(false)
          }

          setCodeUser({ ...myContext, code: v.code })
        }}
        style={{ display: 'flex', gap: 8 }}
      >
        <Form.Item name="code" noStyle>
          <Input placeholder={t('PROMO_CODE_PLACEHOLDER')} disabled={resume?.isUsed} />
        </Form.Item>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => {
            const code = getFieldValue('code')
            return (
              <Button type="primary" htmlType="submit" loading={isLoading} disabled={resume?.isUsed || !code}>
                {t('PROMO_CODE_BUTTON')}
              </Button>
            )
          }}
        </Form.Item>
      </Form>
      {error && <Alert message={t(error?.data?.message || 'Une erreur est survenue')} type="error" />}
    </>
  ) : (
    <div
      style={{
        textDecoration: 'underline',
        cursor: 'pointer',
        marginBottom: 8,
        display: settings?.FO_MEETING_CONFIRMATION_HIDE_PAY ? 'none' : 'visible',
      }}
      onClick={() => setShow(true)}
    >
      {t('PROMO_CODE_SHOW')}
    </div>
  )
}
